import styles from '@components/DataDisplay/SpendingBar/SpendingBar.module.scss'
import cn from '@integrations/classnames'
import { selectMerchantCurrency, useAppSelector } from 'mmfintech-backend-api'
import { formatMoney, tr } from 'mmfintech-commons'
import { ProgressBar } from 'mmfintech-portal-commons'

interface Props {
  totalAmount: number
  spentMonthlyVolume: number
}

function SpendingLimitBar({ totalAmount, spentMonthlyVolume }: Props) {
  const merchantCurrency = useAppSelector(selectMerchantCurrency)

  return (
    <div className={cn(styles['spending-limit-bar-wrapper'], 'spending-limit-bar-wrapper')}>
      <div className={cn(styles['spent-amount'], 'spent-amount')}>
        <div className={cn('available-amount')}>
          <span className={cn(styles['available-text'], 'available-text')}>
            {tr('FRONTEND.EXPENSE_MANAGEMENT.DASHBOARD.MONEY_SPENT', 'Money spent:')}{' '}
            {formatMoney(spentMonthlyVolume, merchantCurrency)}
          </span>
        </div>
        <div className={cn('total-amount')}>{formatMoney(totalAmount, merchantCurrency)}</div>
      </div>
      <ProgressBar value={spentMonthlyVolume} max={totalAmount} />
    </div>
  )
}

export default SpendingLimitBar
